import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { toPaginationOptions } from '@core/utils/to-pagination-options';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { isEmpty } from 'lodash';
import { merge, Subject } from 'rxjs';
import { debounceTime, filter, map, switchMap, takeUntil } from 'rxjs/operators';
import { sentry } from 'sentry';
import { ReportsService } from '../../reports.service';
import { FilterService } from '../filter/filter.service';
import { FormsReportService } from '../services/forms-report.service';
import { Location } from '@angular/common';
var DashboardFormsListComponent = /** @class */ (function () {
    function DashboardFormsListComponent(fuseProgressBarService, formsReportService, reportsService, filterService, route, router, location) {
        this.fuseProgressBarService = fuseProgressBarService;
        this.formsReportService = formsReportService;
        this.reportsService = reportsService;
        this.filterService = filterService;
        this.route = route;
        this.router = router;
        this.location = location;
        this.removeSubscriptions = new Subject();
        this.isLoading = true;
        this.formReportsPage = null;
        this.filterService.selectedForm = null;
    }
    DashboardFormsListComponent.prototype.ngOnInit = function () {
        var _this = this;
        merge(this.filterService.valueChanges.pipe(map(function () { return ({ source: 'filter' }); })), this.paginator.page).pipe(takeUntil(this.removeSubscriptions), filter(function () { return _this.filterService.filterForm.valid; }), debounceTime(200), switchMap(function () { return _this.updateData(); })).subscribe();
        if (this.filterService.filterForm.invalid) {
            this.filterService.filterForm.setValue(this.filterService.defaultFilterValue);
        }
        var queryParams = this.route.snapshot.queryParams;
        if (!isEmpty(queryParams)) {
            return;
        }
        this.filterService.reload();
    };
    DashboardFormsListComponent.prototype.ngOnDestroy = function () {
        if (!this.filterService.isFilterOn) {
            return;
        }
        if (this.filterService.filterForm.invalid) {
            return;
        }
        localStorage.setItem("forms-dashboard-filter", JSON.stringify(this.filterService.filterForm.value));
        this.removeSubscriptions.next();
        this.removeSubscriptions.complete();
    };
    DashboardFormsListComponent.prototype.navigateToDetailPage = function (form) {
        var where = this.filterService.toQuery(this.filterService.value);
        var defaultValues = this.filterService.toQuery(this.filterService.defaultFilterValue);
        var queryParams = this.reportsService.keepOnlyChangedValuesOnQueryParams(where, defaultValues);
        var url = this.router.serializeUrl(this.router.createUrlTree(['relatorios/formularios/detalhes'], {
            queryParams: tslib_1.__assign({ formId_eq: form.formId }, queryParams)
        }));
        console.log('url', url);
        this.filterService.selectedForm = { name: form.name };
        window.open(this.location.prepareExternalUrl(url), '_blank');
    };
    DashboardFormsListComponent.prototype.updateData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var where, _a, err_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.totalCount = 0;
                        this.isLoading = true;
                        this.fuseProgressBarService.show();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        where = this.filterService.toQuery(this.filterService.value);
                        _a = this;
                        return [4 /*yield*/, this.formsReportService
                                .accountFormsAnswers(where, toPaginationOptions({
                                paginator: this.paginator || {
                                    pageSize: 12,
                                    pageIndex: 0
                                }
                            }))];
                    case 2:
                        _a.formReportsPage = _b.sent();
                        this.totalCount = this.formReportsPage.totalCount;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        sentry.captureException(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isLoading = false;
                        this.fuseProgressBarService.hide();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return DashboardFormsListComponent;
}());
export { DashboardFormsListComponent };
